// extracted by mini-css-extract-plugin
export default {"container":"Subtopic_container__15wHz","subtopic-name":"Subtopic_subtopic-name__k6E0d","hit-rate":"Subtopic_hit-rate__B9XtJ","transparent":"Subtopic_transparent__lkmf+"};